// overloaded vueI18n
import { useI18n as useVueI18n } from 'vue-i18n'
import {
  createOntologyRegexesFromKey,
  performOntologyReplacements,
} from '../utils/ontologies'
import { ontologies as ontologiesData } from './useSessionData'

// const startMs = +new Date()
const ontologyKeys = [
  'appointment',
  {
    key: 'child',
    regexPluralPossessive: new RegExp('(^|\\b)children\'s\\b', 'g'),
    regexPlural: new RegExp('(^|\\b)children(?!\\w|\')', 'g'),
  },
  'course',
  'instructor',
  'membership',
  'reservation',
  'room',
  'venue',
]

const ontologies = ontologyKeys.reduce((arr, key) => {
  const ontologyKey = typeof key === 'string' ? key : key.key
  const ontologyConfig = ontologiesData?.[ontologyKey]
  if (ontologyConfig && ontologyConfig.singular.toLowerCase() !== key) {
    arr.push({
      ...createOntologyRegexesFromKey(key),
      configPluralPossessive: ontologyConfig.plural_possessive.toLowerCase(),
      configPlural: ontologyConfig.plural.toLowerCase(),
      configSingularPossessive: ontologyConfig.singular_possessive.toLowerCase(),
      configSingular: ontologyConfig.singular.toLowerCase(),
    })
  }
  return arr
}, [])
// const endMs = +new Date()
// const initialMsPerformanceCost = endMs - startMs

// window.PERF_operations = 0
// window.PERF_totalMsPerformanceCost = initialMsPerformanceCost

export function useI18n(...args) {
  const i18n = useVueI18n(...args)
  const newI18n = { ...i18n }

  if (i18n.locale.value?.includes('en-')) {
    const vue_t = i18n.t
    const t = function (...args) {
      // fix up parameters
      if (args.length === 3) {
        // (string, number, object) => (string, object, number)
        if (typeof args[2] === 'object') {
          const temp = args[2]
          args[2] = args[1]
          args[1] = temp
        }

        if (args[2] === null || args[2] === undefined)
          args[2] = 0

        // custom pluralization for decimals, french
        if (args[2] !== undefined && typeof args[2] === 'number' && args[2] !== 1) {
          if (i18n.locale.value === 'fr')
            args[2] = (args[2] >= 1) ? 2 : 1
          else args[2] = 2
        }
      }
      let translatedString = vue_t(...args)
      ontologies.forEach((ontology) => {
        if (!ontology.regexKeyInsensitive.test(translatedString))
          return
        // window.PERF_operations++
        // const startMs = +new Date()
        translatedString = performOntologyReplacements(translatedString, ontology)
        // const endMs = +new Date()
        // window.PERF_totalMsPerformanceCost += endMs - startMs
      })

      return translatedString
    }

    newI18n.vue_t = vue_t
    newI18n.t = t
  }

  const vue_d = i18n.d
  const d = function () {
    if (typeof arguments[0] === 'string' && !arguments[0].includes('T'))
      arguments[0] = `${arguments[0]}T00:00`
    return vue_d(...arguments)
  }

  return {
    ...newI18n,
    vue_d,
    d,
  }
}
